import { CountryCode } from "libphonenumber-js";
import { useTranslation } from "react-i18next";

import { Line, LineContent, LineFlag, LineTitle } from "@/blocks/Line";
import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import {
  getNumberRoute,
  redirectToDashboard,
} from "@/helpers/navigation/navigation.helpers";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";

export function SectionNumber() {
  const { t } = useTranslation();
  const { line } = useGetLine();

  if (!line) {
    return null;
  }

  const handleOnClick = () => {
    redirectToDashboard(getNumberRoute(line.ID));
  };

  return (
    <Section data-test="number-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.number")}</SectionTitle>
      </SectionHeader>
      <Line
        onClick={handleOnClick}
        number={line.phoneNumber}
        countryCode={line.countryISOCode as CountryCode}
        name={line.name}
      >
        <LineFlag />
        <LineContent>
          <LineTitle />
        </LineContent>
      </Line>
    </Section>
  );
}
